// extracted by mini-css-extract-plugin
export default {"root":"cA6d3AbFpGnISaAGFTfg","nonLink":"HmM2eVFQy278seaya2hP","placeHolderShimmer":"qyl_fduH9cwdkoTlIbOr"};